import { useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";
const Header = () => {
  const [Menu, setMenu] = useState(false);
  const handleClick = () => {
    Menu ? setMenu(false) : setMenu(true);
  };
  return (
    <div className="header">
      <Navbar>
        <Container>
          <Navbar.Brand href="#home">
            <img src="logo.png" alt="logo" />
          </Navbar.Brand>
          <Nav>
            <Nav.Link href="#home">Home</Nav.Link>
            <Nav.Link href="#About">About us</Nav.Link>
            <Nav.Link href="#Explore">Explore Foods</Nav.Link>
            <Nav.Link href="#features">Reviews</Nav.Link>
            <Nav.Link href="#pricing">FAQ</Nav.Link>
            <Button variant="danger" className="button">
              0552 896 77 88
            </Button>
          </Nav>
          <div className="menu">
            <input id="checkbox" type="checkbox" onClick={handleClick} />
            <label className="toggle" htmlFor="checkbox">
              <div id="bar1" className="bars" />
              <div id="bar2" className="bars" />
              <div id="bar3" className="bars" />
            </label>
          </div>
          {Menu && (
            <div className="Menu-Nav danger">
              <Nav.Link href="#home">Home</Nav.Link>
              <Nav.Link href="#home">About us</Nav.Link>
              <Nav.Link href="#home">Explore Foods</Nav.Link>
              <Nav.Link href="#features">Reviews</Nav.Link>
              <Nav.Link href="#pricing">FAQ</Nav.Link>
              <Button variant="danger" className="button">
                0552 896 77 88
              </Button>
            </div>
          )}
        </Container>
      </Navbar>
    </div>
  );
};

export default Header;
